module.exports = __webpack_public_path__ + "img/icon-size-example.051f0a03.svg";